import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

export function getTaxDeductionOwnerCodes({ year }) {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/${year}/dict/tax-deduction-owner-codes`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getObjectNameCodes() {
  return API.request({
    method: 'GET',
    url: `/dictionary/object-name-codes`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getPropertyRightsNDFL3() {
  return API.request({
    method: 'GET',
    url: `/dictionary/property-rights-ndfl3`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getActionTypesForLawyers() {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/2016/dict/tax-practice-types`,
  });
}
